import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b627b244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-option-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-verify" }, "ยืนยันตัวตน"),
  /*#__PURE__*/_createElementVNode("span", { class: "content-verify" }, "เลือกวิธีการตรวจสอบความเป็นเจ้าของบัญชี")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "icon-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ยืนยันผ่าน SMS", -1))
const _hoisted_8 = { class: "icon-container" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-container" }, [
  /*#__PURE__*/_createElementVNode("p", null, "ยืนยันผ่านข้อมูลบนบัตรประชาชน"),
  /*#__PURE__*/_createElementVNode("span", null, "ชื่อ-นามสกุล วันเกิด รหัสหลังบัตรประชาชน")
], -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "otp-card",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.onStepOtp()))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "otp-icon",
              src: require('../../../../assets/img/otp-icon.svg')
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, "ส่งไปที่เบอร์โทรศัพท์ปัจจุบัน: " + _toDisplayString(_ctx.mobileNumber), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: "dopa-card",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.onStepDopa()))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "idcard-icon",
              src: require('../../../../assets/img/idcard-icon.svg')
            }, null, 8, _hoisted_9)
          ]),
          _hoisted_10
        ])
      ])
    ])
  ]))
}